import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";

function Sponsers() {
  return (
    <>
      <br />
      <h1 className="fadein_fadeout2 page-title" style={{color: "#e7a129"}}>
        <FontAwesomeIcon icon={faBuilding} /> Sponsors
      </h1>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <span style={{ color: "gray", fontSize: "1.5rem" }}>Coming Soon...</span>
    </>
  );
}

export default Sponsers;
